<script setup lang="ts">
defineProps<{
  label: string
  name: string
  required?: boolean
  error?: string
  placeholder?: string
}>()

const model = defineModel<string>()

// MultiStepForm renders twice on the same page (§3 preview + §10 final CTA)
// — a raw `name` as the DOM id would collide across both instances (browser
// autofill warning: "Duplicate form field id in the same form").
const uid = useId()
</script>

<template>
  <div class="flex flex-col gap-1">
    <label :for="`${name}-${uid}`" class="text-sm font-semibold text-text">
      {{ label }}<span v-if="required" class="text-red-500">*</span>
    </label>
    <textarea
      :id="`${name}-${uid}`"
      :name="name"
      :required="required"
      :placeholder="placeholder"
      v-model="model"
      rows="2"
      class=" rounded-lg border border-border p-4 text-sm focus:border-coral focus:ring-4 focus:ring-coral-light focus:outline-none"
      :class="{ 'border-red-400': error }">
    </textarea>
    <p v-if="error" class="text-xs text-red-500">{{ error }}</p>
  </div>
</template>
